import { useKeycloak } from '../../components/AuthHOC';
import { useAuthRealm } from './AuthRealmContext';
import { RootAuth } from 'src/pages/Auth/RootAuth';

interface Props {
  children: JSX.Element;
}

const AuthRealmAccessControl = ({ children }: Props) => {
  const { authRealm: currentAuthRealm } = useAuthRealm();
  const { authRealm: authorizedAuthRealm } = useKeycloak();
  const isAuthorized = currentAuthRealm === authorizedAuthRealm;

  return isAuthorized ? children : <RootAuth />;
};

export default AuthRealmAccessControl;
